/// <amd-module name="SuiteCommerce.Blog.TaxonomyNavigation.Taxonomy.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.TaxonomyNavigation.Taxonomy.View", ["require", "exports", "Backbone", "sc_blog_taxonomy_navigation_taxonomy.tpl", "SuiteCommerce.Blog.Common"], function (require, exports, Backbone_1, taxonomyNavigationTaxonomyViewTemplate, Common_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TaxonomyNavigationTaxonomyView = void 0;
    var TaxonomyNavigationTaxonomyView = /** @class */ (function (_super) {
        __extends(TaxonomyNavigationTaxonomyView, _super);
        function TaxonomyNavigationTaxonomyView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = taxonomyNavigationTaxonomyViewTemplate;
            _this.model.on('change', function () { return _this.render(); });
            return _this;
        }
        TaxonomyNavigationTaxonomyView.prototype.getContext = function () {
            return {
                taxonomyName: this.model.name,
                urlFragment: Common_1.BLOG_URL_BASE + "/" + this.model.urlComponent,
                isHighlighted: this.model.isHighlighted,
            };
        };
        return TaxonomyNavigationTaxonomyView;
    }(Backbone_1.View));
    exports.TaxonomyNavigationTaxonomyView = TaxonomyNavigationTaxonomyView;
});
